export default __webpack_public_path__ + "static/media/north-dir-btn.6fad4a98.png";